import { useMutation, useQueryClient } from 'react-query';
import { communicationKeys } from '../../cache-keys/communicationKeys.tsx';
import { useAPI } from '@axo/shared/data-access/provider';
import { email_api } from '@axo/shared/data-access/api';

export function useCreateCommunicationEmail(applicationID: string) {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(email_api.createEmail(api), {
    onSuccess: () =>
      client.invalidateQueries(communicationKeys.emails({ applicationID })),
  });
}
